import { CATEGORY_FROM, isCategorySlug } from '../map/categories';
import { CategoryIcon } from '../map/category-icon';

/**
 * Event cover: the uploaded photo, or a generated placeholder in the category color with its
 * icon (T-306c, D35: no storage). The same event always looks the same (variant from the id).
 */
export function CoverArt({
	eventId,
	category,
	coverUrl,
	className = '',
}: {
	eventId: string;
	category: string;
	coverUrl: string | null;
	className?: string;
}) {
	if (coverUrl !== null) {
		return (
			<img
				src={coverUrl}
				alt=""
				loading="lazy"
				decoding="async"
				className={`object-cover ${className}`}
			/>
		);
	}
	const from = isCategorySlug(category) ? CATEGORY_FROM[category] : 'from-primary';
	const variant = variantOf(eventId);
	return (
		<div
			aria-hidden="true"
			className={`relative overflow-hidden bg-gradient-to-br ${from} to-bg ${className}`}
		>
			<div className="from-text/20 absolute -top-1/4 -left-1/4 size-3/4 rounded-full bg-radial to-transparent" />
			<div
				className={`text-text/25 absolute ${VARIANT_POSITION[variant]} [&_svg]:size-full`}
				style={{ width: '70%', aspectRatio: '1' }}
			>
				<CategoryIcon slug={category} strokeWidth={1.5} />
			</div>
			<div className="text-text absolute inset-0 flex items-center justify-center">
				<CategoryIcon slug={category} className="size-1/4 drop-shadow-lg" strokeWidth={2} />
			</div>
		</div>
	);
}

const VARIANT_POSITION = [
	'-right-[15%] -bottom-[15%] rotate-12',
	'-left-[15%] -bottom-[20%] -rotate-12',
	'-right-[20%] -top-[20%] -rotate-6',
] as const;

function variantOf(id: string): 0 | 1 | 2 {
	let hash = 0;
	for (const char of id) hash = (hash * 31 + char.charCodeAt(0)) >>> 0;
	return (hash % 3) as 0 | 1 | 2;
}
